import T from '@wojtekmaj/react-t';
import { ArrowDown } from 'lucide-react';

import Button from '@rewardopl/react-ui/button';
import Dialog from '@rewardopl/react-ui/dialog';

import { getEmailDomain, getEmailUsername } from '@rewardopl/utils/email';

import { Description, Domain, Email } from './email_typo_dialog.styles';

import { ButtonWrapper } from '@rewardopl/react-ui/dialog/index.styles';

type EmailTypoDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  originalEmail: string;
  setEmail: (email: string) => void;
  suggestedEmail: string;
};

export default function EmailTypoDialog({
  isOpen,
  onClose,
  originalEmail,
  setEmail,
  suggestedEmail,
}: EmailTypoDialogProps) {
  const originalUsername = getEmailUsername(originalEmail);
  const originalDomain = getEmailDomain(originalEmail);

  const suggestedUsername = getEmailUsername(suggestedEmail);
  const suggestedDomain = getEmailDomain(suggestedEmail);

  function onKeepOriginalClick() {
    onClose();
  }

  function onUseSuggestedClick() {
    setEmail(suggestedEmail);
    onClose();
  }

  return (
    <Dialog isOpen={isOpen} onDismiss={onClose} title="Is your email correct?">
      <Description>
        <T>
          Your email looks like it might have a typo. Please double-check or pick the suggested
          correction below.
        </T>
      </Description>
      <Email>
        {originalUsername}
        {'\u200b'}@<Domain color="var(--error-dark)">{originalDomain}</Domain>
      </Email>
      <ArrowDown />
      <Email>
        {suggestedUsername}
        {'\u200b'}@<Domain color="var(--success-dark)">{suggestedDomain}</Domain>
      </Email>
      <ButtonWrapper>
        <Button onClick={onKeepOriginalClick} type="button">
          <T
            originalEmail={`${originalUsername}\u200b@${originalDomain}`}
          >{`Keep {originalEmail}`}</T>
        </Button>
        <Button className="primary" onClick={onUseSuggestedClick} type="button">
          <T
            suggestedEmail={`${suggestedUsername}\u200b@${suggestedDomain}`}
          >{`Use {suggestedEmail}`}</T>
        </Button>
      </ButtonWrapper>
    </Dialog>
  );
}
